import { useMemo } from "react";
import { usePaginatedApi } from "../../../swr/useApi";
import { productRequestsService } from "../../api_client";
import type {
    ProductRequestDto,
    ProductsQueryDto,
} from "../../../api";

type UseProductRequestsOptions = {
    excludeDrafts?: boolean;
};

export function useProductRequests(
    query?: ProductsQueryDto,
    options?: UseProductRequestsOptions,
) {
    const effectiveQuery = useMemo(() => {
        if (!options?.excludeDrafts) return query;
        return {
            ...(query ?? {}),
            isDraft: false,
        } as ProductsQueryDto & { isDraft: boolean };
    }, [options?.excludeDrafts, query]);

    const result = usePaginatedApi<ProductRequestDto, ProductsQueryDto>({
        key: "product-requests",
        serviceMethod: async (queryParams) =>
            await productRequestsService.getAllProductRequests(queryParams as ProductsQueryDto & { isDraft?: boolean }),
        query: effectiveQuery,
    });

    const data = useMemo(() => {
        if (!options?.excludeDrafts || !result.data) {
            return result.data;
        }

        const filteredRows = result.data.data.filter((row) => !row.isDraft);
        return {
            ...result.data,
            data: filteredRows,
            meta: {
                ...result.data.meta,
                totalCount: filteredRows.length,
            },
        };
    }, [options?.excludeDrafts, result.data]);

    return {
        ...result,
        data,
    };
}
